import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OrderService } from '../services/order/order.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private orderService = inject(OrderService);
  private tokenService = inject(TokenService);
  constructor() { }

  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      console.error('HTTP Error:', error.message);
      return;
    }
    if (error instanceof TypeError) {
      console.error('Type Error:', error.message);
      return;
    }
    if (error instanceof Error) {
      switch (error.name) {
        case '404':
          alert('Bestellung konnte nicht gefunden werden');
          this.orderService.resetOrderAndCreateNew();
          break;
        case '401':
          if (error.message === 'invalid order id') {
            console.log('Requesting new token because of invalid order id');
            localStorage.removeItem('accessToken');
            this.tokenService.getToken();
          }
          break;
        case '423':
          this.orderService.orderLockState$.next(true);
          break;
        default:
          console.error('Unknown Error:', error);
      }
      return;
    }
    console.error('Unexpected Error:', error);
  }
  
}
